import { render, staticRenderFns } from "./channelHome.vue?vue&type=template&id=a330855e&scoped=true"
import script from "./channelHome.vue?vue&type=script&lang=js"
export * from "./channelHome.vue?vue&type=script&lang=js"
import style0 from "./channelHome.vue?vue&type=style&index=0&id=a330855e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a330855e",
  null
  
)

export default component.exports